package com.mgacreative.hotel.shared.ui.designsystem.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

private val LightColors = lightColorScheme(
    primary = Color(0xFF2563EB), // Royal Blue Accent
    onPrimary = Color(0xFFFFFFFF),
    primaryContainer = Color(0xFFEFF6FF),
    onPrimaryContainer = Color(0xFF1E40AF),
    secondary = Color(0xFF0EA5E9), // Sky Blue Accent
    onSecondary = Color(0xFFFFFFFF),
    secondaryContainer = Color(0xFFF0F9FF),
    onSecondaryContainer = Color(0xFF0369A1),
    error = Color(0xFFEF4444),
    errorContainer = Color(0xFFFEF2F2),
    onError = Color(0xFFFFFFFF),
    onErrorContainer = Color(0xFF991B1B),
    background = Color(0xFFF8FAFC), // Ultra Clean Light Slate Background
    onBackground = Color(0xFF0F172A), // Crisp Dark Slate Text
    surface = Color(0xFFFFFFFF), // Pure White Surface
    onSurface = Color(0xFF1E293B), // Dark Slate Surface Text
    surfaceVariant = Color(0xFFF1F5F9),
    onSurfaceVariant = Color(0xFF64748B)
)

@Composable
fun HotelTheme(
    useDarkTheme: Boolean = false,
    content: @Composable () -> Unit
) {
    MaterialTheme(
        colorScheme = LightColors,
        typography = AppTypography,
        shapes = AppShapes,
        content = content
    )
}
